import { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
const useStickyNavRouterUrlSync = () => {
  const router = useRouter();
  const routerAsPathRef = useRef(router.asPath);

  const [currentUrl, setCurrentUrl] = useState<string>(() => {
    if (typeof window !== 'undefined' && window.location?.href) {
      return window.location.href;
    }
    return router.asPath || '';
  });

  useEffect(() => {
    routerAsPathRef.current = router.asPath;
  }, [router.asPath]);

  useEffect(() => {
    const updateUrl = () => {
      if (typeof window !== 'undefined' && window.location?.href) {
        setCurrentUrl(window.location.href);
      } else {
        setCurrentUrl(routerAsPathRef.current || '');
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', updateUrl);
    }
    const handleRouteChange = () => {
      updateUrl();
    };
    router.events?.on('routeChangeComplete', handleRouteChange);

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('popstate', updateUrl);
      }
      router.events?.off('routeChangeComplete', handleRouteChange);
    };
  }, [router]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location?.href) {
      const urlFromWindow = window.location.href;
      setCurrentUrl((previousUrl) => (previousUrl !== urlFromWindow ? urlFromWindow : previousUrl));
    } else if (router.asPath) {
      setCurrentUrl((previousUrl) => (previousUrl !== router.asPath ? router.asPath : previousUrl));
    }
  }, [router.asPath]);

  return { currentUrl };
};

export default useStickyNavRouterUrlSync;
